
import * as api from "../../../api"; 


  
export const appDesignSettings = (post) => async (dispatch)=>{
    try {
        const {data } = await api.appDesignSettings(post);
        //  console.log(data)
        if(data?.app){
          dispatch({
            type: "APPDESIGN",
            
            payload:data?.app
          }); 
       
        }
        if(data?.app){return data?.app }
        else if(data?.logout){

          dispatch({type:"LOGOUT"});
        }
        
     } catch (error) {
        // dispatch({
        //     type: "CourseData",
            
        //     payload:{"course":null}
        //   });  
    }
}

